module.exports = __webpack_public_path__ + "static/media/message.686e4854.svg";